import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';
import { ErrorPage, LoadingPage } from '@foradevelopment/fora-ui';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  getAdministrators,
  getPeriodForReportHistory,
  getReportHistory,
} from '../../redux/reportHistory/reportHistoryThunks';
import { getAdministrableEmployers } from '../../redux/employer/employerThunks';
import { resetReportHistory } from '../../redux/reportHistory/reportHistorySlice';

export const ReportHistoryDataFetcher = () => {
  const dispatch = useAppDispatch();
  const partnerNumberOrganization = useAppSelector(state => state.auth.user?.selectedPartnerNumberOrganization);
  const loadingAdministrableEmployers = useAppSelector(state => state.employer.loadingAdministrableEmployers);

  useEffect(() => {
    dispatch(getAdministrableEmployers());
    if (partnerNumberOrganization) {
      dispatch(getPeriodForReportHistory({ partnerNumberOrganization: partnerNumberOrganization }));
      dispatch(getReportHistory({ partnerNumberOrganizations: [partnerNumberOrganization] }));
      dispatch(getAdministrators({ partnerNumberOrganization: partnerNumberOrganization }));
    }
  }, [dispatch, partnerNumberOrganization]);

  useEffect(() => {
    return () => {
      dispatch(resetReportHistory());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loadingAdministrableEmployers === ThunkRequestStatus.Fulfilled) {
    return <Outlet />;
  }
  if (loadingAdministrableEmployers === ThunkRequestStatus.Rejected) {
    return <ErrorPage type={500} />;
  }
  return <LoadingPage />;
};
